import { render, staticRenderFns } from "./MainFullBanner.vue?vue&type=template&id=3c1d6d97&scoped=true&"
import script from "./MainFullBanner.vue?vue&type=script&lang=js&"
export * from "./MainFullBanner.vue?vue&type=script&lang=js&"
import style0 from "./MainFullBanner.vue?vue&type=style&index=0&id=3c1d6d97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d6d97",
  null
  
)

export default component.exports